import axios from 'axios';
import { Toast } from 'vant';
import { tokenTransformer, userAuthGuardHandler } from './http';

const CompositionHttp = axios.create({
  baseURL: process.env.VUE_APP_CQCB_API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

// 拦截器
CompositionHttp.interceptors.request.use((config) => {
  // 如果是请求后端签名上传图片接口，则不加token请求头
  const regForUploader = new RegExp('/oss/upload/get.php');
  if (
    window.gettoken() &&
    window.gettoken() !== 'null' &&
    !regForUploader.test((config as any).url)
  ) {
    config.headers.Authorization = `${tokenTransformer(window.gettoken())}`;
  }
  return config;
});

CompositionHttp.interceptors.response.use(
  (res) => {
    if (res && res.status === 200 && res.data) {
      userAuthGuardHandler(res);
      return res.data;
    } else {
      return Promise.reject();
    }
  },
  (err) => {
    const { response = {} } = err;
    if (response.status === 500) {
      Toast.loading({
        duration: 3000,
        message: '服务器开小差了,后台工作人员正在努力解决',
      });
    }
  },
);
export { CompositionHttp };
